import { Component, OnInit, DoCheck, OnDestroy, ViewChild, HostListener} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { LoginService } from 'src/app/managers/login.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { MatDrawer } from '@angular/material';
import { Subscription } from 'rxjs';
import { OutputDataService } from 'src/app/common/services/output-data.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent extends BaseComponent implements OnInit, DoCheck, OnDestroy {
  @ViewChild('drawer', { static: true }) drawer: MatDrawer
  private _onMenuOpenedSubscription: Subscription;
  sideMenu: string;
  componentHeight: string;
  
  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _outputDataService: OutputDataService) {
    super(route, loginManager, clientConfig, dialog);
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.setComponentHeight();
  }

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
    this._onMenuOpenedSubscription = this._outputDataService.onMenuOpened.subscribe(x => this.toggleMenu(x));
    this.setComponentHeight();
  }

  ngDoCheck() {
    this.refresh();
  }
  
  ngOnDestroy() {
    super.ngOnDestroy();
    this._onMenuOpenedSubscription.unsubscribe();
  }

  onMyselfUpdate() {
  }

  private refresh() {
    this.sideMenu = this.params['sideMenu'];
    this.dataSource = this.getDataSource();          
  }

  private getDataSource(): any {
    if (this.sideMenu === 'myself')
      return this.getLoggedinUser();
    else if (this.sideMenu === 'otherUsers')
      return null;      
    else
      return null;
  }

  private toggleMenu(opened: boolean): void {
    if (opened)
      this.drawer.open();
    else
      this.drawer.close();
  }

  private setComponentHeight() {
    let screenHeight: number = window.innerHeight;
    let screenWidth: number = window.innerWidth;
    this.componentHeight = screenHeight - 128 + 'px';  
  }
}


